module.exports = __webpack_public_path__ + "files/31cbd1e120475f658f84544c1ef7f79a.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-5.png
// module id = 523
// module chunks = 76